import { Object3D, PerspectiveCamera } from "three"
import { CrawlControls } from "../lib/CrawlControls"
import C from "../lib/Constants"

export default class BirdCamera
{
    constructor(_options)
    {
        this.time = _options.time
        this.sizes = _options.sizes
        this.cursor = _options.cursor

        this.instance = null
        this.container = new Object3D()
        this.container.name = 'camera_container'
        this.container.matrixAutoUpdate = false

        this.setInstance()
    }

    setInstance()
    {
        this.instance = new PerspectiveCamera(C.CAMERA.fov, this.sizes.width / this.sizes.height, C.CAMERA.clipNear, C.CAMERA.clipFar)

        this.sizes.on('resize', () =>
        {
            this.instance.aspect = this.sizes.width / this.sizes.height
            this.instance.updateProjectionMatrix()
        })
        this.sizes.resize()

        this.container.add(this.instance)
    }

    setControls(renderer)
    {
        this.controls = new CrawlControls(this.instance, renderer.domElement, this.cursor)
        this.controls.target.copy(C.CAMERA.targetStartPosition)
        this.instance.position.copy(C.CAMERA.startPosition)

        this.controls.enableDamping = true
        this.controls.dampingFactor = 0.035
        this.controls.zoomDampingFactor = 0.03

		this.controls.rotateSpeed = 0.18
        this.controls.crawlSpeed = C.VARS.isMobile ? 8 : 5
        this.controls.zoomSpeed = 40

        this.controls.minDistance = C.VARS.isMobile ? C.CAMERA.controlsMinDistMobile : C.CAMERA.controlsMinDistDesktop
        this.controls.maxDistance = C.VARS.isMobile ? C.CAMERA.controlsMaxDistMobile : C.CAMERA.controlsMaxDistDesktop

        this.controls.minCrawl = C.SCENE.minBoundary
        this.controls.maxCrawl = C.SCENE.maxBoundary

		this.controls.minPhi = Math.PI * 0.45
		this.controls.maxPhi = 0.45

        this.controls.cursorMovementEnabled = false
        this.controls.cursorMovementDamping = 0.025

        this.time.on("tick", () =>
        {
            this.controls.update()
        })
    }
}